import { defineStore } from "pinia";
import { ref } from "vue";

export const useDebtorsStore = defineStore('useDebtorsStore', () => {
    const isNeedUpdateDebtors = ref<boolean>(false);

    return {
        isNeedUpdateDebtors,
    };
});
